<template>
  <div class="mv_agentdesc">
    <breadcrumb
      :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'代理商管理',src:'/mv_channel/agent'},{name:detail.name}]"
    ></breadcrumb>
    <div class="mv_agentdesc-wrap">
      <div class="mv_agentdesc-contain">
        <page-title :title="detail.name"></page-title>
        <detail-card :title="'基本信息'">
          <div class="mv_agentdesc-row_wrap">
            <el-row>
              <el-col :span="5">所在省：{{detail.provName}}</el-col>
              <el-col :span="5">类型：{{detail.typeName}}</el-col>
              <el-col :span="5">ID：{{detail.id}}</el-col>
              <el-col :span="9">地址：{{detail.addr}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="5">邮编：{{detail.postcode}}</el-col>
              <el-col :span="5">联系人：{{detail.contact}}</el-col>
              <el-col :span="5">职位：{{detail.position}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="5">手机：{{detail.phoen}}</el-col>
              <el-col :span="5">固定电话：{{detail.telephoen}}</el-col>
              <el-col :span="5">传真：{{detail.fax}}</el-col>
            </el-row>
            <el-row>
              <el-col>备注：{{detail.content}}</el-col>
            </el-row>
              <el-row>
              <el-col :span="15">创建者/日期：{{detail.createName}}/{{detail.createTime?detail.createTime.split('T')[0]:""}}</el-col>
              <el-col :span="9">最近修改：{{detail.updateName}}/{{detail.updateTime?detail.updateTime.split('T')[0]:""}}</el-col>
            </el-row>
          </div>
          <div>
            <el-button @click="edit()">
              <font-awesome-icon
                style="color:#9b9b9b; margin-right:6px;"
                :icon="['fas', 'pencil-alt']"
              />编辑
            </el-button>
            <el-button @click="delAgent()" type="danger" plain>删除</el-button>
          </div>
        </detail-card>
        <detail-card :title="'客户列表'">
          <div class="mv_agentdesc-row_wrap">
            <div class="mv_agentdesc-table">
              <table>
                <tr>
                  <th>单位</th>
                  <th>省份</th>
                  <th>卡号</th>
                  <th>平台</th>
                  <th>日期</th>
                  <th>类型</th>
                  <th>状态</th>
                  <th>到款</th>
                </tr>
                <tr v-for="item in clientsList" :key="item.clientId">
                  <td><a @click="gotoDetail(item.clientId)">{{item.clientName}}</a></td>
                  <td>{{item.areaName}}</td>
                  <td>{{item.clientCardno}}</td>
                  <td>{{item.platformName}}</td>
                  <td>{{item.starttime.split('T')[0]}} - {{item.stoptime.split('T')[0]}}</td>
                  <td>{{item.typeName}}</td>
                  <td>{{item.contractStatusDesc}}</td>
                  <td>{{item.receiveDesc}}</td>
                </tr>
              </table>
            </div>
            <el-pagination
              @current-change="changePage"
              :current-page="params.page"
              class="mv_agentdesc-pagination"
              background
              layout="prev, pager, next"
              :total="listSize"
            ></el-pagination>
          </div>
        </detail-card>
      </div>
    </div>
    <!--代理商表单-->
    <el-dialog class="mv_agentdesc-dialog" title="代理商信息" :visible.sync="agentFormShow">
      <el-form label-position="top" class="mv_agentdesc-form">
        <el-row :gutter="15">
          <el-col :span="16">
            <el-form-item label="代理商名称">
              <el-input clearable placeholder="请输入" v-model="agentForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="省份">
              <el-select clearable placeholder="请选择" v-model="agentForm.provid">
                <el-option
                  v-for="item in providList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="类别">
              <el-select clearable placeholder="请选择" v-model="agentForm.type">
                <el-option
                  v-for="item in platformList"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input clearable placeholder="请输入" v-model="agentForm.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务">
              <el-input clearable placeholder="请输入" v-model="agentForm.position"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="手机">
              <el-input clearable placeholder="请输入" v-model="agentForm.phoen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="固话">
              <el-input clearable placeholder="请输入" v-model="agentForm.telephoen"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <el-input clearable placeholder="请输入" v-model="agentForm.fax"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="16">
            <el-form-item label="地址">
              <el-input clearable placeholder="请输入" v-model="agentForm.addr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮编">
              <el-input clearable placeholder="请输入" v-model="agentForm.postcode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="备注">
              <el-input clearable placeholder="请输入" v-model="agentForm.content"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAgentForm">提 交</el-button>
        <el-button @click="agentForm= false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "@/servies/axios";
import api from "@/servies/api";
import pageTitle from "@/components/pageTitle";
import breadcrumb from "@/components/breadcrumb";
import detailCard from "@/components/detailCard";
export default {
  components: {
    pageTitle,
    breadcrumb,
    detailCard
  },
  data() {
    return {
      id: "",
      detail: "",
      agentForm: {
        addr: "",
        contact: "",
        content: "",
        fax: "",
        name: "",
        phoen: "",
        position: "",
        postcode: "",
        provid: "",
        telephoen: "",
        type: ""
      },

      agentFormShow: false,

      platformList: [],
      providList: [],
      clientsList: [],
      listSize: 0,

      params: {
        pageSize: 10,
        page: 1,
        agent: ""
      }
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getDetail();
    this.getSelectList();
    this.getClientList();
  },
  methods: {
    getDetail() {
      // 获取详情
      axios
        .get(api.agentInfo + `?id=${this.id}`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取代理商详情成功", res.data.result);
            this.detail = res.data.result[0];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    getSelectList() {
      Promise.all([
        //获取平台
        axios.get(api.getPlatformTypeList).then(res => {
          if (res.data.code === 0) {
            console.log("获取平台成功", res.data.result);
            this.platformList = res.data.result;
          } else {
            console.log("获取平台失败", res.data.msg);
          }
        }),
        //获取省-市-区列表
        axios.post(api.areaListAuth).then(res => {
          if (res.data.code === 0) {
            console.log("获取省-市-区列表成功", res.data.result);
            this.providList = res.data.result;
          } else {
            console.log("获取省-市-区列表失败", res.data.msg);
          }
        })
      ])
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error("网络错误，稍后重试");
        });
    },
    changePage(v){
      this.params.page = v
      this.getClientList()
    },
    getClientList() {
      this.params.agent = this.id;
      axios
        .post(api.movieClientList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取电影台客户资料列表成功", res.data.result);
            this.clientsList = res.data.result.pageResult.records;
            this.listSize = res.data.result.pageResult.total;
          } else {
            console.log("获取电影台客户资料列表失败", res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    delAgent() {
      this.$confirm("删除后不可恢复，确认删除？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        axios
          .get(api.deleteagent + `?id=${this.id}`)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: "删除代理商成功",
                type: "success"
              });
              this.$router.push({ path: `/mv_channel/agent` });
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.$message.error("网络错误，稍后重试");
          });
      });
    },
    //查看详情
    gotoDetail(id) {
      this.$router.push({ path: `/mv_channel/detail/${id}`,query: { agent: this.detail.name }})
    },
    edit() {
      this.agentForm = _.pick(this.detail, _.keys(this.agentForm));
      this.agentForm.id = this.id;
      this.agentFormShow = true;
    },
    submitAgentForm() {
      let params = _.cloneDeep(this.agentForm);
      axios
        .post(api.updateAgent, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "修改代理商成功",
              type: "success"
            });
            this.agentFormShow = false;
            this.getDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.mv_agentdesc {
  .mv_agentdesc-wrap {
    padding: 77px 30px 0px 30px;
    .mv_agentdesc-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
			.el-row {
        padding: 13px 20px;
        &:nth-child(odd) {
          background: #f1f5f9;
        }
        &:nth-child(even) {
          background: #ffffff;
        }
      }
      .mv_agentdesc-row_wrap {
        margin-bottom: 19px;
        .mv_agentdesc-table {
          margin-top: 16px;
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .mv_agentdesc-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .mv_agentdesc-dialog {
    .el-dialog {
      min-width: 745px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }
    .mv_agentdesc-form {
      .mv_agentdesc-title {
        margin-bottom: 20px;
        color: #4a4a4a;
        font-weight: 600;
        font-size: 18px;
      }
      .el-form-item {
        .el-select {
          width: 100%;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 22px;
          margin-top: 3px;
          padding-bottom: 11px;
        }
        .el-radio-group {
          height: 40px;
          align-items: center;
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-checkbox-group {
          border-radius: 4px;
          border: 1px solid rgba(220, 223, 230, 1);
          padding: 0px 20px 0 14px;
          display: flex;
          justify-content: space-between;
        }
        .el-date-editor {
          width: 100%;
        }
      }
      .mv_agentdesc-checkbox {
        height: 38px;
        line-height: 38px;
        padding: 0px 13px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
        margin-top: 36px;
      }
    }
  }
}
</style>
